import { Metamodel } from 'app/model/base/model';
import { AmazonRdsForOracleDataset } from 'app/model/dataset/amazon-rds-for-oracle.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { OracleCopySource } from './oracle.copysource';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.amazonRdsForOracle.copySourceType,
    display: [
        format(stringResources.ModelName_CopySourceTemplate, stringResources.AmazonRdsForOracle_DisplayText),
        format(stringResources.ModelName_CopySourcesTemplate, stringResources.AmazonRdsForOracle_DisplayText)
    ],
    tags: { datasetModel: Metamodel.modelFor(AmazonRdsForOracleDataset) }
})
export class AmazonRdsForOracleCopySource extends OracleCopySource {
}
